export const MAX_ZOOM_IN = 20;

/** Zoom scale 1 means we can't zoom any further out */
export const MAX_ZOOM_OUT = 1;
